<template>
  <div class="main-trip-list-blk">
    <div class="trip-header-blk" :class="{ 'tobe-verified-header': [0, 3].includes(verifiedStatus) }">
      <!-- <v-checkbox dense hide-details v-if="verifiedStatus === 10" v-model="selectedStatus" @change="selectAllTrips"></v-checkbox> -->
      <span class="id-blk">Trip ID </span>
      <!-- <span class="date-blk" v-if="verifiedStatus === 10">Invoice No</span> -->
      <span class="date-blk">Date</span>
      <span class="time-blk">Time</span>
      <span class="trip-type">Trip type</span>
      <span class="user-blk">Crew Details</span>
      <span class="driver-blk">Driver</span>
            <span class="driver-blk">Vehicle No</span>
      <span class="package-blk">Slab</span>
      <span class="package-blk">Total Kms Travelled</span>
      <span class="fare-blk" v-if="ownerId == 1">Fare</span>
      <span class="remarks-blk" v-if="![0, 3].includes(verifiedStatus)">Remarks</span>
      <span class="action-blk" v-if="listType === 'dispute'">Actions</span>
    </div>
    <div class="trip-list-blk" v-for="(data, index) in tripList" :key="index" :class="{ 'tobe-verified': [0, 3].includes(verifiedStatus) }">
      <!-- :class="{ 'verified-status': verifiedStatus === 10 }" -->
      <div class="id-blk content-blk">
        <!-- <span v-if="verifiedStatus === 10"><v-checkbox dense hide-details v-model="data.verified" @change="selectTrips(data)"></v-checkbox></span> -->
        <div class="detailed-column">
          <a @click="openDrawer(data.bigId)">{{ data.id }}</a>
          <v-tooltip bottom color="#363636" v-if="data.invoiceGenerated">
            <template v-slot:activator="{ on, attrs }">
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="18px" viewBox="0 0 20 20" width="18px" fill="#0aa430" v-on="on" v-bind="attrs">
                <g><rect fill="none" height="20" width="20" /></g>
                <g>
                  <path
                    d="M18,10l-1.77-2.03l0.25-2.69l-2.63-0.6l-1.37-2.32L10,3.43L7.53,2.36L6.15,4.68L3.53,5.28l0.25,2.69L2,10l1.77,2.03 l-0.25,2.69l2.63,0.6l1.37,2.32L10,16.56l2.47,1.07l1.37-2.32l2.63-0.6l-0.25-2.69L18,10z M8.59,13.07l-2.12-2.12l0.71-0.71 l1.41,1.41l4.24-4.24l0.71,0.71L8.59,13.07z"
                  />
                </g>
              </svg>
            </template>
            <span>Invoice Generated</span>
          </v-tooltip>
        </div>
        <!-- <span class="status-blk started-status-blk" v-if="data.status.id === 7">Started</span> -->
        <!-- <v-tooltip top v-if="data.employees && data.employees.length > 1" color="black">
          <template v-slot:activator="{ on, attrs }">
            <i style="cursor: pointer" class="fas fa-user-friends" v-on="on" v-bind="attrs"></i>
          </template>
          <div class="tooltip-content">
            <ul class="employee-list">
              <li v-for="(item, employeeIndex) in data.employees" :key="employeeIndex">{{ item.name }}</li>
            </ul>
          </div>
        </v-tooltip> -->
      </div>
      <!-- <div class="date-blk content-blk" v-if="verifiedStatus === 10">
        <span>{{ data.invoiceNo ? data.invoiceNo : "---" }}</span>
      </div> -->

      <div class="date-blk content-blk">
        <span>{{ getDate(data.schedule_date) }}</span>
      </div>
      <div class="time-blk content-blk">
        <span>{{ getTime(data.schedule_date) }}</span>
      </div>
      <div class="trip-type content-blk">
        <span>{{ data.tripType }}</span>
      </div>
      <div class="user-blk content-blk">
        <ul style="margin: 0; padding-left: 16px">
          <li v-for="(employee, employeeIndex) in data.employees" :key="employeeIndex" class="crew-details">
            <span>{{ employee.name }} <span v-if="employee.gender">( <strong>{{ employee.gender }}</strong> )</span></span
            ><span class="extra-info">Crew ID: {{ employee.crewid }}</span>
          </li>
        </ul>
      </div>
      <div class="driver-blk content-blk">
        <span>{{ data.driver.name }}</span>
      </div>
        <div class="driver-blk content-blk">
        <span>{{ data.vehicleNo }}</span>
      </div>

      <div class="package-blk content-blk">
        <span>{{ data.package }}</span>
      </div>
      <div class="package-blk content-blk">
        <span>{{ data.driverfare.km }}KM</span>
      </div>
      <div class="fare-blk content-blk" v-if="ownerId == 1">
        <span>₹ {{ data.userSubTotal }}</span>
      </div>
      <div class="remarks-blk content-blk" v-if="![0, 3].includes(verifiedStatus)">
        <span> <v-btn color="#1076a6" x-small @click="showRemarks(data)">Remark</v-btn> </span>
      </div>
      <div class="action-blk content-blk" v-if="listType === 'dispute'">
        <span> <v-btn color="#118e4f" x-small @click="openrdDialog(data.bigId)">Resolve</v-btn></span>
      </div>
    </div>

    <v-navigation-drawer v-model="drawer" absolute temporary width="1200">
      <TripDetails :tripId="tripId" v-if="drawer" @closeTripDetails="closeTripDetails"></TripDetails>
    </v-navigation-drawer>
    <v-dialog width="500" v-model="rdDialog" persistent>
      <v-card class="card-modal-view">
        <v-card-title>Resolve Dispute</v-card-title>
        <v-card-text>
          <div class="file-list">
            <v-chip v-for="(file, index) in files" :key="index" small close outlined @click:close="removeFile(file, index)"
              >{{ file.name.slice(0, 10) }}{{ file.name.length > 10 ? "..." : "" }}</v-chip
            >
          </div>
          <div>
            <!-- hint="File size should be less than 2MB" -->
            <v-file-input truncate-length="50" placeholder="Upload Document" v-model="rectifiedFile" accept=".jpg,.png,.pdf"></v-file-input>
          </div>
          <div>
            <v-textarea v-model="remarks" rows="1" placeholder="Remarks" @input="checkValidation"></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions style="display: flex; justify-content: flex-end; gap: 10px">
          <v-btn small color="#ed5e5e" @click="closeResolve">Close</v-btn>
          <v-btn small color="#eea004" @click="submitReview" :disabled="files.length === 0 || !remarks">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remarksDialog" width="60%" :scrollable="false">
      <v-card class="card-modal-view">
        <v-card-title>Remarks</v-card-title>
        <v-card-text class="remarks-list">
          <v-data-table :headers="headers" :items="tripRemarks" :items-per-page="-1" dense hide-default-footer fixed-header max-height="calc(100vh - 300px)">
            <template v-slot:item.date="{ item }">
              <td>{{ getDateTime(item.date) }}</td>
            </template>
            <template v-slot:item.type="{ item }">
              <td>
                <v-chip small :color="getColor(item.type)">
                  {{ showRemarksType(item.type) }}
                </v-chip>
              </td>
            </template>
            <template v-slot:item.image="{ item }">
              <td>
                <div class="content-block file-block" v-if="item.rectifiedFiles">
                  <span class="image-view" @click="previewImage(item.rectifiedFiles)" v-if="checkPdfImage(item.rectifiedFiles, 'image')">View Image</span>
                  <span v-if="checkPdfImage(item.rectifiedFiles, 'pdf')" class="image-view" @click="previewPdf(item.rectifiedFiles)">View PDF</span>
                </div>
                <span v-else class="content-block">---</span>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions style="display: flex; justify-content: flex-end">
          <v-btn small color="#ed5e5e" @click="remarksDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <viewer ref="viewerRef" :images="selectedImages" @show="onViewerShow"></viewer>
    </v-card>

    <v-dialog v-model="pdfViewer" width="800px">
      <v-card>
        <div class="pdf-buttons">
          <v-btn v-for="(file, index) in pdfSrc" :key="index" small @click="selectPdf(file, index + 1)" color="#286a92"> PDF {{ index + 1 }} </v-btn>
        </div>
        <object width="100%" :data="currentPdf" style="height: 90vh; overflow: auto"></object>
      </v-card>
    </v-dialog>
    <Loading v-if="loading"></Loading>
    <Confirm ref="confirm"></Confirm>
  </div>
</template>

<script>
import * as moment from "moment";
import TripDetails from "@/components/Trips/trip-details/TripDetails";
import TollAdd from "@/components/Trips/TollAdd";
import Loading from "@/components/common/Loading";
import Confirm from "@/components/common/Confirm";
import StartEndDialog from "@/components/Trips/trips-view/StartEndDialog";
import axios from "../../../axios/axios-global";

import { encryptUtil } from "../../../Utils/decrypt";
export default {
  name: "TripsView",
  components: { StartEndDialog, Confirm, Loading, TripDetails, TollAdd },
  props: {
    tripList: Array,
    listType: String,
    tab: Number,
    verifiedStatus: Number,
    ownerId: String,
  },
  data: () => {
    return {
      drawer: false,
      tripId: 0,
      loading: false,
      tollDialog: false,
      bigId: 0,
      status: "",
      rdDialog: false,
      remarks: "",
      rectifiedFile: null,
      files: [],
      remarksDialog: false,
      headers: [
        { text: "Date", value: "date", sortable: false },
        { text: "Status", value: "type", sortable: false },
        { text: "Remarks", value: "remark", sortable: false },
        { text: "Image", value: "image", sortable: false },
      ],
      tripRemarks: [],
      selectedImages: [],
      viewerApi: null,

      selectedStatus: false,

      pdfSrc: [],
      pdfViewer: false,

      currentPdf: "",
      page: 1,
      totalPages: 1,
    };
  },
  methods: {
    getDate(data) {
      return data ? moment(data).format("DD-MM-YYYY") : "-";
    },
    getTime(data) {
      return data ? moment(data).format("HH:mm") : "-";
    },
    getDateTime(data) {
      return data ? moment(data).format("DD-MM-YYYY HH:mm") : "-";
    },
    openDrawer(id) {
      this.drawer = true;
      this.tripId = id;
    },
    closeTripDetails() {
      this.drawer = false;
    },
    closeDialog() {
      this.startDialog = false;
    },
    openrdDialog(id) {
      this.rdDialog = true;
      this.bigId = id;
    },
    showRemarks(data) {
      this.remarksDialog = true;
      this.tripRemarks = data.corporateverificationLog ? data.corporateverificationLog : [];
      this.$nextTick(() => {
        if (this.$refs.viewerRef && this.$refs.viewerRef.$viewerApi) {
          this.viewerApi = this.$refs.viewerRef.$viewerApi;
        }
      });
    },
    getColor(type) {
      if (!type) return "";
      let style = ["Invoice Cancelled", "dispute"].includes(type) ? "#ed5e5e" : type === "response" ? "#facc15" : "#4caf50";
      return style;
    },
    showRemarksType(type) {
      switch (type) {
        case "dispute":
          return "Dispute";
        case "response":
          return "Rectified";
        case "Invoice Cancelled":
          return "Invoice Cancelled";
        case "invoice Generated":
          return "Invoice Generated";
        default:
          return "Verified";
      }
    },
    closeResolve() {
      this.rdDialog = false;
      this.remarks = "";
      this.files = [];
      this.rectifiedFile = null;
    },
    removeFile(file, index) {
      this.files.splice(index, 1);
    },
    async submitReview() {
      this.loading = true;
      try {
        let formData = new FormData();
        let requestBody = {
          response: this.remarks,
          tripid: this.bigId,
        };
        const setencryptUtil = new encryptUtil({ decrypt: requestBody });
        const data = setencryptUtil.getEncryptedData();
        formData.append("data", data);
        this.files.map((file) => formData.append("image", file));
        //   formData.append("image", this.files);
        let response = await axios.post("/trip/dispute/resolve", formData);
        if (response && response.status === 200) {
          this.loading = false;
          this.rdDialog = false;
          this.$toasted.show(response.data.message, {
            position: "bottom-center",
            duration: 5000,
          });
          this.$emit("disputeResolved");
        } else {
          this.$toasted.show(response.data.message, {
            position: "bottom-center",
            duration: 5000,
          });
        }
      } catch (error) {
        this.loading = false;
      }
    },

    checkPdfImage(imageSrc, type) {
      console.log(imageSrc);
      if (type === "pdf") {
        return imageSrc.some((doc) => this.isPdf(doc));
      } else {
        return imageSrc.some((doc) => !this.isPdf(doc));
      }
    },

    previewPdf(pdfSrc) {
      this.pdfSrc = [];

      pdfSrc.forEach((doc) => {
        if (this.isPdf(doc)) this.pdfSrc.push(doc);
      });
      this.totalPages = this.pdfSrc.length;
      if (this.pdfSrc.length > 0) this.currentPdf = this.pdfSrc[0];
      this.pdfViewer = true;
    },

    previewImage(imageSrc) {
      this.selectedImages = [];
      let reorderedImages = [];
      imageSrc.forEach((doc) => {
        if (!this.isPdf(doc)) reorderedImages.push(doc);
      });
      this.selectedImages = reorderedImages;
      if (this.viewerApi) {
        this.viewerApi({ images: this.selectedImages, options: { inline: false } });
      } else {
        console.error("Viewer API is not initialized yet.");
      }
    },
    isPdf(url) {
      return url && url.toLowerCase().includes(".pdf");
    },
    onViewerShow() {
      console.log("Viewer is initialized and ready.");
    },
    selectPdf(file, page) {
      this.currentPdf = file;
      this.page = page;
    },

    checkValidation() {
      this.remarks = this.remarks.replace(/^\s+/, "");
    },

    // selectTrips(trip) {
    //   if (trip.verified === true) {
    //     if (this.tripList.every((trip) => trip.verified === true)) this.selectedStatus = true;
    //     this.$emit("selectTrips", { trip: trip, status: true });
    //   } else {
    //     if (this.tripList.some((trip) => trip.verified === false)) this.selectedStatus = false;
    //     this.$emit("selectTrips", { trip: trip, status: false });
    //   }
    // },
    // selectAllTrips() {
    //   if (this.selectedStatus) {
    //     this.tripList.map((trip) => {
    //       this.$set(trip, "verified", true);
    //     });
    //     const trips = this.tripList.map((trip) => trip.id);
    //     this.$emit("allSelect", trips);
    //   } else {
    //     this.tripList.map((trip) => {
    //       this.$set(trip, "verified", false);
    //     });
    //     this.$emit("allSelect", []);
    //   }
    // },
  },
  watch: {
    tab() {
      console.log("tab", this.tab);
      this.$emit("fetchTrips");
    },
    rectifiedFile() {
      if (this.rectifiedFile) this.files.push(this.rectifiedFile);
      console.log(this.files);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../trips-view/tripView.scss";

::v-deep .v-data-table {
  .v-data-table__wrapper {
    table {
      tr {
        // th {
        //  width: 150px;
        // }
        td {
          padding: 8px 16px;
          max-width: 150px;
          border-bottom: 1px solid #0000001f;
          .image-view {
            font-size: 12px;
            color: #155b8a;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        th,
        td {
          text-align: center !important;
        }
      }
    }
  }
}

.file-list {
  display: flex;
  gap: 10px;
}

.detailed-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

::v-deep .v-file-input .v-file-input__text {
  font-size: 12px;
}
::v-deep .v-input {
  font-size: 12px;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.pdf-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  .v-btn {
    color: white;
  }
}

.file-block {
  display: flex;
  flex-direction: column;
}

.crew-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    text-align: center;
    word-break: auto-phrase;
    hyphens: auto;
  }
  .extra-info {
    color: #08008b;
    font-weight: bold;
  }
}
// .v-chip.v-size--small {
//   height: 18px;
//   color: #fff;
// }
</style>
